import { render } from "./Policy.vue.ts?vue&type=template&id=a2c1f8e3&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Policy.vue?vue&type=template&id=a2c1f8e3&scoped=true&ts=true"
import script from "./Policy.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Policy.vue?vue&type=script&setup=true&lang=ts"
export * from "./Policy.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Policy.vue?vue&type=script&setup=true&lang=ts"

import "./Policy.vue.scss?vue&type=style&index=0&id=a2c1f8e3&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Policy.vue?vue&type=style&index=0&id=a2c1f8e3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c1f8e3"],['__file',"src/apps/merchant3/components/steps/policy/Policy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2c1f8e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2c1f8e3', __exports__)) {
    api.reload('a2c1f8e3', __exports__)
  }
  
  module.hot.accept("./Policy.vue.ts?vue&type=template&id=a2c1f8e3&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Policy.vue?vue&type=template&id=a2c1f8e3&scoped=true&ts=true", () => {
    api.rerender('a2c1f8e3', render)
  })

}


export default __exports__